import React from 'react';
import { Box } from '@mui/material';
import { Base, Win01, Win02 } from '../../../assets/images/tournamentLine';

/**
 * TournamentLine Component
 * @param {Object} props
 * @param {string} props.prop - 상태: "base" | "win 01" | "win 02"
 * @param {string} props.prop1 - 방향: "위" | "아래"
 * @param {Object} props.sx - 추가 스타일
 * @param {Object} props...props - 기타 props
 */
export const TournamentLine = ({ prop = "base", prop1 = "위", sx = {}, ...props }) => {
    const containerStyles = {
        position: 'relative',
        width: '100%',
        height: '100%',
        ...sx
    };

    // win 01 + 위
    if (prop === "win 01" && prop1 === "위") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '1.19%',
                    left: 0,
                    right: '4.54%',
                    top: '1.19%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.21%',
                        left: 0,
                        right: '-2.34%',
                        top: '-1.22%'
                    }}>
                        <Base
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: '1.19%',
                    left: 0,
                    right: '4.54%',
                    top: '1.19%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.21%',
                        left: 0,
                        right: '-2.34%',
                        top: '-1.22%'
                    }}>
                        <Win01
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
            </Box>
        );
    }

    // win 02 + 위
    if (prop === "win 02" && prop1 === "위") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: '4.54%',
                    top: '2.38%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.21%',
                        left: 0,
                        right: '-2.34%',
                        top: '-1.22%'
                    }}>
                        <Base
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: '4.54%',
                    top: '33.33%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.31%',
                        left: 0,
                        right: '-2.34%',
                        top: '-1.79%'
                    }}>
                        <Win02
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
            </Box>
        );
    }

    // base + 아래
    if (prop === "base" && prop1 === "아래") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '1.19%',
                    left: 0,
                    right: '4.54%',
                    top: '1.19%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '41px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.21%',
                                left: 0,
                                right: '-2.34%',
                                top: '-1.22%'
                            }}>
                                <Base
                                    alt=""
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    // win 01 + 아래
    if (prop === "win 01" && prop1 === "아래") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '1.19%',
                    left: 0,
                    right: '4.54%',
                    top: '1.19%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '41px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.21%',
                                left: 0,
                                right: '-2.34%',
                                top: '-1.22%'
                            }}>
                                <Base
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: '1.19%',
                    left: 0,
                    right: '4.54%',
                    top: '1.19%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '41px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.21%',
                                left: 0,
                                right: '-2.34%',
                                top: '-1.22%'
                            }}>
                                <Win01
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    // win 02 + 아래
    if (prop === "win 02" && prop1 === "아래") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: '4.54%',
                    top: '2.38%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '41px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.21%',
                                left: 0,
                                right: '-2.34%',
                                top: '-1.22%'
                            }}>
                                <Base
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: '30.95%',
                    left: 0,
                    right: '4.54%',
                    top: '2.38%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '28px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.31%',
                                left: 0,
                                right: '-2.34%',
                                top: '-1.79%'
                            }}>
                                <Win02
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    // 기본 상태 (base + 위)
    return (
        <Box sx={containerStyles} {...props}>
            <Box sx={{
                position: 'absolute',
                bottom: '1.19%',
                left: 0,
                right: '4.54%',
                top: '1.19%'
            }}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '-0.21%',
                    left: 0,
                    right: '-2.34%',
                    top: '-1.22%'
                }}>
                    <Base
                        alt=""
                        style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TournamentLine;
